import React from "react";

export const PeopleConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: "/activity-management/people",
      component: React.lazy(() => import("./People"))
    }
  ]
};
